module.exports = __webpack_public_path__ + "img/jimnyForm.2d7a98ac.svg";